import { useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { MdCenterFocusWeak, MdExpandMore, MdOutlineFilterCenterFocus } from 'react-icons/md';
import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton, Tooltip, Typography } from '@mui/material';

import { linkAccordionStyles } from './styles';
import { loadZone } from 'shared/loadZoneSlice';
import { LinkButton } from '../LinkButton';

import { selectActiveTheme } from 'GeminiViewerComponent/features/globals/themeSlice';
import {
    setSelectedSearchItemId,
    getActiveAssetActiveZone,
    getSelectedSearchItemId,
} from 'GeminiViewerComponent/features/asset/assetSlice';

const LinkAccordion = ({ headerLabel, headerIcon, links, linkTypes, isZoneMedia, setOpen }) => {
    const dispatch = useDispatch();
    const theme = useSelector(selectActiveTheme);
    const activeZone = useSelector(getActiveAssetActiveZone);
    const selectedSearchItemId = useSelector(getSelectedSearchItemId);

    const classes = linkAccordionStyles(theme);

    const handleMediaItemClick = useCallback(
        async (id, zone_id) => {
            if (zone_id !== activeZone?.zone_id) {
                await dispatch(loadZone({ zoneId: zone_id, searchItemId: id }));
            } else {
                await dispatch(setSelectedSearchItemId(id));
            }
        },
        [activeZone]
    );

    const getContentType = (link) => {
        return linkTypes[link.link_type?.link_type_id]?.label.toLowerCase().replaceAll(' ', '-') ?? '';
    };

    return (
        <div>
            <Accordion>
                <AccordionSummary
                    id={`viewer_zone-media_${headerLabel.toLowerCase()}-accordion`}
                    className={classes.sectionHeader}
                    expandIcon={<MdExpandMore className={`react-icon ${classes.expandIcon}`} />}
                >
                    <Typography className={classes.heading}>
                        {headerIcon && <span className={classes.icon}>{headerIcon}</span>}
                        {headerLabel} ({links.length})
                    </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.links}>
                    {links.map((link, idx) => {
                        if (isZoneMedia) {
                            return (
                                <Box key={link?.link_id} display="flex" alignItems="center" gap="5px">
                                    {link?.zone_id === activeZone?.zone_id ? (
                                        <IconButton
                                            id={`viewer_zone-media_${getContentType(link)}_nav-${idx}`}
                                            data-item-id={link.item_id}
                                            data-link-id={link.link_id}
                                            data-content-type={getContentType(link)}
                                            color="inherit"
                                            edge="start"
                                            onClick={() => {
                                                handleMediaItemClick(link.item_id, link?.zone_id || null);
                                            }}
                                        >
                                            <MdOutlineFilterCenterFocus
                                                className={`react-icon ${classes.expandIcon}`}
                                            />
                                        </IconButton>
                                    ) : (
                                        <Tooltip title={link?.zone_display_name}>
                                            <IconButton
                                                id={`viewer_zone-media_${getContentType(link)}_nav-${idx}`}
                                                item-id={link.item_id}
                                                link-id={link.link_id}
                                                content-type={getContentType(link)}
                                                color="inherit"
                                                edge="start"
                                                onClick={() => {
                                                    handleMediaItemClick(link.item_id, link?.zone_id || null);
                                                }}
                                            >
                                                <MdCenterFocusWeak className={`react-icon ${classes.expandIcon}`} />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    <Box
                                        width="100%"
                                        overflow="hidden"
                                        className={clsx([
                                            selectedSearchItemId === link.item_id && classes.linkButtonWrapper,
                                        ])}
                                    >
                                        <LinkButton
                                            link={link}
                                            allLinks={links}
                                            setOpen={setOpen}
                                            idx={idx}
                                            contentType={getContentType(link)}
                                        />
                                    </Box>
                                </Box>
                            );
                        } else {
                            return (
                                <LinkButton
                                    key={link?.link_id}
                                    allLinks={links}
                                    link={link}
                                    setOpen={setOpen}
                                    idx={idx}
                                    contentType={getContentType(link)}
                                />
                            );
                        }
                    })}
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

// create new user

export { LinkAccordion };
